module.exports = __webpack_public_path__ + "img/img_dm_produce@3x.a7147005.png";